import { createFileRoute } from '@tanstack/react-router'
import {
  ClipboardCheck,
  Database,
  Server,
  Box,
  Rocket,
  MoreHorizontal,
  Clock,
} from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/main-workspace')({
  component: RouteComponent,
})

function RouteComponent() {
  return <MainWorkSpace />
}

function MainWorkSpace() {
  const { t } = useTranslation()

  const services = [
    {
      icon: <ClipboardCheck className="h-6 w-6" />,
      name: t('routes.main-workspace.services.items.quizz'),
      href: '/quizz',
    },
    {
      icon: <Database className="h-6 w-6" />,
      name: t('routes.main-workspace.services.items.storage'),
      href: '/storage',
    },
    {
      icon: <Server className="h-6 w-6" />,
      name: t('routes.main-workspace.services.items.api'),
      href: '/api',
    },
    {
      icon: <Box className="h-6 w-6" />,
      name: t('routes.main-workspace.services.items.resources'),
      href: '/resources',
    },
    {
      icon: <Rocket className="h-6 w-6" />,
      name: t('routes.main-workspace.services.items.deployments'),
      href: '/deploy',
    },
  ]

  const resources = [
    {
      name: 'quiz-app-api',
      type: t('routes.main-workspace.resources.table.headers.type'),
      lastViewed: t('routes.main-workspace.resources.table.timeFormats.weeks', {
        count: 3,
      }),
    },
    {
      name: 'quiz-backend',
      type: t('routes.main-workspace.resources.table.headers.type'),
      lastViewed: t('routes.main-workspace.resources.table.timeFormats.weeks', {
        count: 4,
      }),
    },
    {
      name: 'quiz-storage',
      type: 'Resource group',
      lastViewed: t('routes.main-workspace.resources.table.timeFormats.month'),
    },
  ]

  return (
    <div className="flex flex-col max-w-5xl mx-auto p-6 space-y-8">
      <section>
        <h2 className="text-2xl font-bold mb-4">
          {t('routes.main-workspace.services.title')}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {services.map((service, index) => (
            <Card key={index} className="hover:bg-muted/50 transition-colors">
              <CardContent className="p-4">
                <a
                  href={service.href}
                  className="flex flex-col items-center text-center space-y-2"
                >
                  {service.icon}
                  <span className="text-sm font-medium">{service.name}</span>
                </a>
              </CardContent>
            </Card>
          ))}
          <Card className="hover:bg-muted/50 transition-colors">
            <CardContent className="p-4">
              <Button
                variant="ghost"
                className="w-full h-full flex flex-col items-center space-y-2"
              >
                <MoreHorizontal className="h-6 w-6" />
                <span className="text-sm font-medium">
                  {t('routes.main-workspace.services.items.more')}
                </span>
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4">
          {t('routes.main-workspace.resources.title')}
        </h2>
        <Card>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>
                  {t('routes.main-workspace.resources.table.headers.name')}
                </TableHead>
                <TableHead>
                  {t('routes.main-workspace.resources.table.headers.type')}
                </TableHead>
                <TableHead>
                  {t(
                    'routes.main-workspace.resources.table.headers.lastViewed'
                  )}
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {resources.map((resource, index) => (
                <TableRow key={index}>
                  <TableCell className="font-medium">
                    <div className="flex items-center space-x-2">
                      <Server className="h-4 w-4" />
                      <span>{resource.name}</span>
                    </div>
                  </TableCell>
                  <TableCell>{resource.type}</TableCell>
                  <TableCell>
                    <div className="flex items-center space-x-2">
                      <Clock className="h-4 w-4" />
                      <span>{resource.lastViewed}</span>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </section>
    </div>
  )
}
